import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Loader from './utils/Loader';
import NavigationBar from './components/NavigationBar';
import Footer from './components/Footer';

const Home = lazy(() => import('./components/Home'));
const Contact = lazy(() => import('./components/Contact/Contact'));
const Blogs = lazy(() => import('./components/Blog/Blogs'));
const Blog = lazy(() => import('./components/Blog/Blog'));
const Projects = lazy(() => import('./components/Project/Projects'));
const Work = lazy(() => import('./components/Work/Work'));

// Loading component for Suspense fallback
const PageLoader = () => (
  <div className="page-loader">
    <Loader />
  </div>
);

function ReactRoutes() {
  return (
    <Router>
      <div className="home">
        <NavigationBar />
        <div className="route-page">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/contact" element={<Contact />} />
              <Route exact path="/projects" element={<Projects />} />
              <Route exact path="/work" element={<Work />} />
              <Route exact path="/blogs" element={<Blogs />} />
              <Route exact path="/blogs/:slug" element={<Blog />} />
            </Routes>
          </Suspense>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default ReactRoutes;
